import * as React from 'react';
import { DayPanel } from './DayPanel';
import { areDatesInSameDay, isEventsExistInDate, visibleDays } from '../../../../helpers/calendar/calendar';

interface Props {
  onClick: (date) => void;
  selectedDate: Date;
  monthAndYearDate: Date;
  nowDate: Date;
  eventDates: Date[];
  eventDateTypes?: Record<string, string[]>;
}

export function MonthDaysPanel(props: Props) {
  const { nowDate, selectedDate, monthAndYearDate, onClick, eventDates, eventDateTypes = {} } = props;
  const year = monthAndYearDate.getFullYear();
  const month = monthAndYearDate.getMonth();
  const datesToDraw = visibleDays(year, month);

  return (
    <div className="cal-grid">
      {datesToDraw.map(date => {
        const dateMonth = date.getMonth();
        const dateKey = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
        const eventTypes = eventDateTypes[dateKey] || [];
        const dataAtDate = isEventsExistInDate(date, eventDates);
        const isOtherMonth = dateMonth !== month;
        const isToday = areDatesInSameDay(date, nowDate);
        const isSelected = areDatesInSameDay(date, selectedDate);

        return (
          <DayPanel
            key={`${date.getFullYear()}_${date.getMonth()}_${date.getDate()}`}
            isActive={dataAtDate}
            isSelected={isSelected}
            isToday={isToday}
            isNextMonth={isOtherMonth}
            isPrevMonth={isOtherMonth}
            onClick={() => onClick(date)}
            dayName={date.getDate()}
            eventTypes={eventTypes}
          />
        );
      })}
    </div>
  );
}